/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon';
icon.register({
	'minus-sign': {
		width: 1,
		height: 1,
		viewBox: '0 0 16 16',
		data: '<path pid="0" d="M15 8H1" _stroke="currentColor" stroke-width="2.5" _fill="none"/>'
	}
});
